<template>
  <router-view />
</template>

<script>
export default {
  name: 'EmptyLayout',
};
</script>



// WEBPACK FOOTER //
// src/layouts/empty-layout.vue